import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-icon-bar-chart-square-up',
  standalone: true,
  templateUrl: './rt-icon-bar-chart-square-up.component.html',
  styleUrls: ['./rt-icon-bar-chart-square-up.component.scss']
})
export class RtIconBarChartSquareUpComponent {
  @Input() width: number | string = 16;
  @Input() height: number | string = 16;
}
